import React from 'react';
import {Link} from 'react-router-dom';
import {useAuth} from '../contexts/AuthContext';

export default function NotFound() {
  const {currentUser}=useAuth();
  return <main className="money-surface min-h-screen flex items-center justify-center p-6">
    <div className="max-w-sm">
      <p className="money-eyebrow">404</p>
      <h1 className="mt-2 text-3xl font-semibold">Page not found</h1>
      <p className="mt-3 money-muted">This link may have changed. Head back to FinFlow to continue.</p>
      <Link to={currentUser?"/dashboard":"/login"} className="money-primary mt-6">Back to FinFlow</Link>
    </div>
  </main>;
}
